import localStorageUtils from "@iso/lib/helpers/localStorageUtils";

const actions = {
  INFI_CHECK_AUTHORIZATION: "INFI_CHECK_AUTHORIZATION",
  INFI_LOGIN_REQUEST: "INFI_LOGIN_REQUEST",
  INFI_LOGOUT: "INFI_LOGOUT",
  INFI_LOGIN_SUCCESS: "INFI_LOGIN_SUCCESS",
  INFI_LOGIN_ERROR: "INFI_LOGIN_ERROR",
  INFI_SIGN_UP_REQUEST: "INFI_SIGN_UP_REQUEST",
  INFI_SIGN_UP_SUCCESS: "INFI_SIGN_UP_SUCCESS",
  INFI_SIGN_UP_ERROR: "INFI_SIGN_UP_ERROR",
  INFI_AUTH_CLEAR_STATUS: "INFI_AUTH_CLEAR_STATUS",
  checkAuthorization: () => ({ type: actions.INFI_CHECK_AUTHORIZATION }),
  login: (username, password) => {
    // Clear localStorage
    localStorageUtils.clearLoginInfo();
    return {
      type: actions.INFI_LOGIN_REQUEST,
      username,
      password
    };
  },
  logout: () => {
    localStorageUtils.clearLoginInfo();
    return {
      type: actions.INFI_LOGOUT
    };
  },
  signUp: (username, password, firstName, lastName, email, phone) => {
    return {
      type: actions.INFI_SIGN_UP_REQUEST,
      payload: { username, password, firstName, lastName, email, phone }
    };
  },
  clearStatus: () => {
    return {
      type: actions.INFI_AUTH_CLEAR_STATUS
    };
  }
};

const infiAuthActions = actions;

export default infiAuthActions;
